import { render, staticRenderFns } from "./Festivals.vue?vue&type=template&id=47f19a0b&scoped=true&"
import script from "./Festivals.vue?vue&type=script&lang=js&"
export * from "./Festivals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f19a0b",
  null
  
)

export default component.exports